import tracking from "./tracking";

const beforeStepChange = state => {
  if (!state.isInitialising) {
    const dataLayer = state.data.Steps[state.activeStep].DataLayer;

    if (
      !dataLayer ||
      state.activeTemplate == "flow-choice" ||
      state.activeTemplate == "tile-selection" ||
      state.activeTemplate == "button-selection"
    ) {
      return;
    }

    tracking({
      eventAction: dataLayer.eventaction
      // eventLabel: eventLabel
    });
  }

  if (state.activeTemplate === "success") {
    tracking({
      eventAction: "Success"
    });
  }
};

export default beforeStepChange;
